import React from 'react';
import { formatDate, dashBoardformatDate } from 'utils';
// import { fetchConfigarationData, kudzuPlusTrueFun } from '../../../helpers/utils/Utils';
import { fetchConfigarationData, kudzuPlusTrueFun } from 'helpers/utils/Utils';
import { useSelector, useDispatch } from 'react-redux';
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi';
import Delete from '../../../../../../assets/smi-kudzu-images/delete_icon.png'
import Edit from '../../../../../../assets/smi-kudzu-images/edit_icon.png'

const appConfigData = await fetchConfigarationData();

const ScheduleBillersData = ({ transactionData, redirectToScheduleDetailsDetails , details}) => {
  const { BillerName, AccountNumber , PaymentDate, Amount} = transactionData;
  const dispatch = useDispatch();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const styleAll = `font-[400] my-auto font-[500] font-hanken-grotesk md:text-[18px] sm:text-[11px] text-[16px]`
  const styleStatus = `font-[400] y-auto font-hanken-grotesk md:text-[18px] md:text-[17px] sm:text-[11px] text-[16px] `
  const formattedDate = dashBoardformatDate(PaymentDate);
  const date = formattedDate;
  //text-[#262B3A]
  const formatCurrency = (value) => {
  if (value == null) return "$0.00";
  return `$${Number(value).toFixed(2)}`;
};

  return (
    <tr className="">
      <td onClick={ () => {redirectToScheduleDetailsDetails(transactionData)}} className={`${kudzuPlusTrue ? "text-white": "text-black"} pb-5 cursor-pointer text-left font-[500] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem]
       max-w-[11rem] break-words  ${styleAll} 
        text-[var(--text-clr-transactions)]`}>
        {BillerName}
      </td>

       <td onClick={ () => {redirectToScheduleDetailsDetails(transactionData)}} className={`${kudzuPlusTrue ? "text-white": "text-black"} pb-5 cursor-pointer text-left font-[500] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem]
       max-w-[11rem] break-words  ${styleAll} 
        text-[var(--text-clr-transactions)]`}>
        {date}
      </td>

       <td className={`sm:table-cell flex justify-end items-center pb-5 text-right font-[500] lg:max-w-[11rem] md:max-w-[10rem] sm:max-w-[6rem] max-w-[11rem] ${styleAll} text-[var(--text-clr-transactions)]`}>
        {formatCurrency(Amount)}
      </td>
    </tr>
  );
};



export default ScheduleBillersData;
